/* Payrick theme · global script */
(function () {
  'use strict';

  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const LS = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  const SS = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  /* copy text: Clipboard API, with a fallback for in-app browsers that block it */
  const copyText = (t) => new Promise((ok, no) => {
    const legacy = () => {
      try {
        const ta = document.createElement('textarea');
        ta.value = t; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
        document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, t.length);
        const r = document.execCommand('copy'); ta.remove(); r ? ok() : no();
      } catch (e) { no(e); }
    };
    try { if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext !== false) navigator.clipboard.writeText(t).then(ok, legacy); else legacy(); } catch (e) { legacy(); }
  });

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, p = 2, t = ',', d = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    };
    const m = format.match(re);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    if (document.body.dataset.hideZeroDecimals === 'true') v = v.replace(/[.,]00$/, '');
    return format.replace(re, v);
  }
  T.formatMoney = formatMoney;

  /* ---------- events ---------- */
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const rafThrottle = fn => { let q = false; return () => { if (q) return; q = true; requestAnimationFrame(() => { q = false; fn(); }); }; };

  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 3200);
  }
  T.toast = toast;
  T.lockScroll = (on, key) => lockScroll(on, key);

  /* ---------- scroll lock ---------- */
  const lockSet = new Set();
  function lockScroll(on, key = 'default') {
    if (on) lockSet.add(key); else lockSet.delete(key);
    document.documentElement.style.overflow = lockSet.size ? 'hidden' : '';
    document.documentElement.classList.toggle('is-locked', lockSet.size > 0);
  }

  /* ---------- cart ---------- */
  const CART_SECTION = 'cart-drawer';
  let internalCartCall = 0;

  const Cart = {
    async get() { return (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json(); },

    async add(items, opts = {}) {
      const body = Array.isArray(items) ? { items } : items;
      internalCartCall++;
      try {
        const res = await fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
        await Cart.refresh();
        emit('cart:added', { items: data });
        const dr = $('#CartDrawer');
        if (opts.open !== false && (!dr || dr.dataset.openOnAdd !== 'false')) Cart.open();
        return data;
      } finally { internalCartCall--; }
    },

    async change(line, quantity) {
      internalCartCall++;
      try {
        const res = await fetch(T.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
        await Cart.refresh();
        return data;
      } finally { internalCartCall--; }
    },

    async update(updates) {
      internalCartCall++;
      try {
        await fetch(T.routes.cartUpdate + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(updates)
        });
      } finally { internalCartCall--; }
    },

    async refresh() {
      const pageEl = $('[data-cart-page]');
      const pageId = pageEl && pageEl.dataset.sectionId;
      const url = `${T.routes.root.replace(/\/$/, '')}/?sections=${CART_SECTION}${pageId ? ',' + pageId : ''}`;
      const [sections, cart] = await Promise.all([
        fetch(url).then(r => r.json()).catch(() => ({})),
        Cart.get()
      ]);
      if (sections[CART_SECTION]) {
        const doc = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
      }
      if (pageId && sections[pageId]) {
        const doc = new DOMParser().parseFromString(sections[pageId], 'text/html');
        const fresh = doc.querySelector('[data-cart-page]');
        const cur = $('[data-cart-page]');
        if (fresh && cur) cur.replaceWith(fresh);
      }
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      emit('cart:updated', { cart });
      return cart;
    },

    open() {
      if (T.cartType !== 'drawer' || !$('#CartDrawer')) { window.location.href = T.routes.cart; return; }
      const d = $('#CartDrawer');
      if (d.classList.contains('is-open')) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      lockScroll(true, 'cart');
      setTimeout(() => { const c = $('.drawer__close', d); c && c.focus({ preventScroll: true }); }, 50);
      emit('cart:open');
    },

    close() {
      const d = $('#CartDrawer');
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      lockScroll(false, 'cart');
    }
  };
  T.cart = Cart;
  // Common globals other apps look for
  window.refreshCart = () => Cart.refresh();
  window.openCartDrawer = () => Cart.open();

  /* Watch cart calls made by apps (Kaching Bundles, upsell apps, etc.) and keep the drawer in sync */
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  const onExternalCart = debounce(async (isAdd) => {
    await Cart.refresh();
    if (isAdd) { const d = $('#CartDrawer'); if (!d || d.dataset.openOnAdd !== 'false') Cart.open(); }
  }, 120);

  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = origFetch.apply(this, arguments);
    if (CART_RE.test(url) && !internalCartCall) {
      if (/\/cart\/add/.test(url)) T.lastExternalAdd = Date.now();
      p.then(r => { if (r.ok) onExternalCart(/\/cart\/add/.test(url)); }).catch(() => {});
    }
    return p;
  };
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cUrl = url;
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._cUrl && CART_RE.test(this._cUrl) && !internalCartCall) {
      const u = this._cUrl;
      if (/\/cart\/add/.test(u)) T.lastExternalAdd = Date.now();
      this.addEventListener('load', () => { if (this.status < 400) onExternalCart(/\/cart\/add/.test(u)); });
    }
    return origSend.apply(this, arguments);
  };

  /* Drawer + cart page interactions (delegated, survive re-render) */
  document.addEventListener('click', async (e) => {
    const t = e.target;

    const openCart = t.closest('[data-open-cart]');
    if (openCart && T.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); Cart.open(); return; }

    if (t.closest('[data-close-cart]')) { e.preventDefault(); Cart.close(); return; }

    const qtyBtn = t.closest('[data-qty-btn]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.qty');
      const input = $('input', wrap);
      const step = qtyBtn.dataset.qtyBtn === 'plus' ? 1 : -1;
      const min = parseInt(input.min || 0, 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const remove = t.closest('[data-remove-line]');
    if (remove) {
      e.preventDefault();
      const item = remove.closest('.cart-item');
      item && item.classList.add('is-loading');
      try { await Cart.change(parseInt(remove.dataset.removeLine, 10), 0); } catch (err) { toast(err.message); item && item.classList.remove('is-loading'); }
      return;
    }

    const upsell = t.closest('[data-upsell-add]');
    if (upsell) {
      e.preventDefault();
      const card = upsell.closest('.upsell-card');
      const sel = card && $('select', card);
      const id = sel ? sel.value : upsell.dataset.upsellAdd;
      upsell.classList.add('loading');
      try { await Cart.add({ items: [{ id: parseInt(id, 10), quantity: 1 }] }); } catch (err) { toast(err.message); }
      upsell.classList.remove('loading');
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) {
      const item = input.closest('.cart-item');
      item && item.classList.add('is-loading');
      try { await Cart.change(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10) || 0); }
      catch (err) { toast(err.message); await Cart.refresh(); }
      return;
    }
    if (e.target.matches('[data-cart-note]')) Cart.update({ note: e.target.value });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    Cart.close();
    $$('.menu-drawer.is-open, .search-modal.is-open, .popup.is-open, .lightbox.is-open').forEach(el => el.dispatchEvent(new CustomEvent('close')));
  });

  /* ---------- header ---------- */
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.header-wrapper') || this;
      this.mode = this.dataset.sticky || 'none';
      this.lastY = window.scrollY;
      const setH = () => document.documentElement.style.setProperty('--header-h', this.wrapper.offsetHeight + 'px');
      setH(); window.addEventListener('resize', debounce(setH, 150));
      window.addEventListener('scroll', rafThrottle(() => this.onScroll()), { passive: true });
      this.onScroll();

      const drawer = $('.menu-drawer', this);
      $$('[data-menu-open]', this).forEach(b => b.addEventListener('click', () => this.toggleMenu(true)));
      if (drawer) {
        $$('[data-menu-close]', drawer).forEach(b => b.addEventListener('click', () => this.toggleMenu(false)));
        drawer.addEventListener('close', () => this.toggleMenu(false));
      }
      const search = $('.search-modal', this);
      $$('[data-search-open]', this).forEach(b => b.addEventListener('click', (e) => { if (search) { e.preventDefault(); this.toggleSearch(true); } }));
      if (search) {
        $$('[data-search-close]', search).forEach(b => b.addEventListener('click', () => this.toggleSearch(false)));
        search.addEventListener('close', () => this.toggleSearch(false));
      }
    }
    onScroll() {
      if (document.documentElement.classList.contains('is-locked')) return;
      const y = Math.max(0, window.scrollY);
      const h = this.wrapper.offsetHeight;
      this.wrapper.classList.toggle('is-scrolled', y > 10);
      if (this.mode === 'scroll-up') {
        const sec = this.wrapper.closest('.shopify-section') || this.wrapper;
        const dy = y - this.lastY;
        if (y <= h) sec.classList.remove('header-hidden');
        else if (dy > 6) sec.classList.add('header-hidden');
        else if (dy < -6) sec.classList.remove('header-hidden');
      }
      if (Math.abs(y - this.lastY) > 6 || y <= h) this.lastY = y;
    }
    toggleMenu(open) {
      const d = $('.menu-drawer', this);
      if (!d) return;
      if (open) (this.wrapper.closest('.shopify-section') || this.wrapper).classList.remove('header-hidden');
      d.classList.toggle('is-open', open);
      lockScroll(open, 'menu');
      $$('[data-menu-open]', this).forEach(b => b.setAttribute('aria-expanded', open));
    }
    toggleSearch(open) {
      const s = $('.search-modal', this);
      s.classList.toggle('is-open', open);
      lockScroll(open, 'search');
      if (open) setTimeout(() => { const i = $('input[type=search]', s); i && i.focus(); }, 50);
    }
  }
  customElements.define('site-header', SiteHeader);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type=search]', this);
      this.results = $('[data-predictive-results]', this);
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', debounce(() => this.search(), 250));
    }
    async search() {
      const q = this.input.value.trim();
      if (!q) { this.results.innerHTML = ''; return; }
      try {
        const r = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=6`);
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const res = doc.querySelector('[data-predictive-content]');
        this.results.innerHTML = res ? res.innerHTML : '';
      } catch (e) { this.results.innerHTML = ''; }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* ---------- announcement slider ---------- */
  class AnnouncementSlider extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.announcement__slide', this);
      if (this.slides.length < 2) return;
      this.i = 0;
      const ms = (parseInt(this.dataset.speed, 10) || 4) * 1000;
      this.timer = setInterval(() => this.go(this.i + 1), ms);
      $$('[data-ann-prev]', this).forEach(b => b.addEventListener('click', () => this.go(this.i - 1)));
      $$('[data-ann-next]', this).forEach(b => b.addEventListener('click', () => this.go(this.i + 1)));
    }
    go(n) {
      this.slides[this.i].classList.remove('is-active');
      this.i = (n + this.slides.length) % this.slides.length;
      this.slides[this.i].classList.add('is-active');
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('announcement-slider', AnnouncementSlider);

  /* ---------- media gallery ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('.gallery__track', this);
      this.slides = $$('.gallery__slide', this);
      this.thumbs = $$('.gallery__thumb', this);
      this.dots = $$('.gallery__dots button', this);
      this.counter = $('[data-gallery-counter]', this);
      this.thumbsWrap = $('.gallery__thumbs', this);
      this.index = 0;

      $$('[data-gallery-prev]', this).forEach(b => b.addEventListener('click', () => this.go(this.index - 1)));
      $$('[data-gallery-next]', this).forEach(b => b.addEventListener('click', () => this.go(this.index + 1)));
      $$('[data-thumbs-prev]', this).forEach(b => b.addEventListener('click', () => this.thumbsWrap.scrollBy({ left: -this.thumbsWrap.clientWidth * .6 })));
      $$('[data-thumbs-next]', this).forEach(b => b.addEventListener('click', () => this.thumbsWrap.scrollBy({ left: this.thumbsWrap.clientWidth * .6 })));
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

      const syncFromScroll = () => {
        const w = this.track.clientWidth || 1;
        const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w)));
        if (i !== this.index && getComputedStyle(this.track).display === 'flex') this.setActive(i);
      };
      this.track.addEventListener('scroll', debounce(syncFromScroll, 60), { passive: true });
      this.track.addEventListener('scrollend', syncFromScroll, { passive: true });
      // iOS (esp. Low Power Mode) only lets a video start inside a real tap/touch.
      // On the first touch we "unlock" every gallery video, so swiping to one can autoplay it.
      const unlock = () => {
        $$('video', this).forEach((v) => {
          if (v.dataset.autoplay !== 'true' || v.dataset.unlocked) return;
          v.dataset.unlocked = '1'; v.muted = true; v.playsInline = true;
          const p = v.play();
          if (p && p.then) p.then(() => { if (!v.closest('.gallery__slide.is-active')) v.pause(); }).catch(() => {});
        });
      };
      this.track.addEventListener('touchstart', unlock, { passive: true, once: true });
      this.track.addEventListener('pointerdown', unlock, { passive: true, once: true });

      if (this.dataset.lightbox === 'true') {
        this.slides.forEach((s, i) => {
          const img = $('img[data-zoom]', s);
          if (img) s.addEventListener('click', () => this.openLightbox(i));
        });
      }
      this.setActive(0, true);
      if (this.dataset.initialMedia) { const i = this.slides.findIndex(x => x.dataset.mediaId == this.dataset.initialMedia); if (i > 0) requestAnimationFrame(() => { this.track.scrollLeft = this.slides[i].offsetLeft - this.track.offsetLeft; this.setActive(i, true); }); }
    }
    go(i) {
      const n = this.slides.length;
      if (!n) return;
      i = this.dataset.loop === 'true' ? (i + n) % n : Math.max(0, Math.min(n - 1, i));
      const s = this.slides[i];
      if (getComputedStyle(this.track).display === 'flex') this.glide(s.offsetLeft - this.track.offsetLeft);
      else s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.setActive(i);
    }
    glide(to) {
      // a touch quicker than the browser's default smooth scroll
      const t = this.track, from = t.scrollLeft, dist = to - from;
      if (!dist) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { t.scrollLeft = to; return; }
      cancelAnimationFrame(this.raf);
      const dur = 300, start = performance.now(), snap = t.style.scrollSnapType, beh = t.style.scrollBehavior;
      t.style.scrollSnapType = 'none'; t.style.scrollBehavior = 'auto';
      const ease = (x) => 1 - Math.pow(1 - x, 3);
      const step = (now) => {
        const p = Math.min(1, (now - start) / dur);
        t.scrollLeft = from + dist * ease(p);
        if (p < 1) this.raf = requestAnimationFrame(step);
        else { t.style.scrollSnapType = snap; t.style.scrollBehavior = beh; }
      };
      this.raf = requestAnimationFrame(step);
    }
    goToMedia(id) {
      const i = this.slides.findIndex(s => s.dataset.mediaId == id);
      if (i > -1) this.go(i);
    }
    setActive(i, initial) {
      this.index = i;
      this.slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === i);
        const v = $('video', s);
        if (v) {
          if (k === i && v.dataset.autoplay === 'true') {
            // phones only allow autoplay without a tap when the video is truly muted + inline
            v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
            const p = v.play(); if (p && p.catch) p.catch(() => { v.addEventListener('canplay', () => v.play().catch(() => {}), { once: true }); });
          } else if (k !== i) v.pause();
        }
      });
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      if (this.counter) this.counter.textContent = `${i + 1} / ${this.slides.length}`;
      const t = this.thumbs[i];
      if (t && !initial && this.thumbsWrap) {
        const l = t.offsetLeft - this.thumbsWrap.offsetLeft - (this.thumbsWrap.clientWidth - t.clientWidth) / 2;
        this.thumbsWrap.scrollTo({ left: l, behavior: 'smooth' });
      }
    }
    openLightbox(i) {
      let lb = $('#Lightbox');
      if (!lb) {
        lb = document.createElement('div');
        lb.id = 'Lightbox';
        lb.className = 'lightbox';
        lb.innerHTML = `<button class="lightbox__close" aria-label="Close">${icon('close')}</button><button class="lightbox__nav lightbox__nav--prev" aria-label="Previous">${icon('chev-left')}</button><img alt=""><button class="lightbox__nav lightbox__nav--next" aria-label="Next">${icon('chev-right')}</button>`;
        document.body.appendChild(lb);
        lb.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('.lightbox__close')) lb.dispatchEvent(new CustomEvent('close')); });
        lb.addEventListener('close', () => { lb.classList.remove('is-open'); lockScroll(false, 'lightbox'); });
      }
      const imgs = this.slides.map(s => $('img[data-zoom]', s)).filter(Boolean);
      let k = Math.max(0, imgs.indexOf($('img[data-zoom]', this.slides[i])));
      const show = () => { $('img', lb).src = imgs[k].dataset.zoom; };
      $('.lightbox__nav--prev', lb).onclick = () => { k = (k - 1 + imgs.length) % imgs.length; show(); };
      $('.lightbox__nav--next', lb).onclick = () => { k = (k + 1) % imgs.length; show(); };
      show();
      lb.classList.add('is-open');
      lockScroll(true, 'lightbox');
    }
  }
  customElements.define('media-gallery', MediaGallery);

  function icon(n) {
    const p = {
      close: '<path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
      'chev-left': '<path d="M13 4l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
      'chev-right': '<path d="M7 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'
    };
    return `<svg viewBox="0 0 20 20" aria-hidden="true">${p[n]}</svg>`;
  }

  class DeferredMedia extends HTMLElement {
    connectedCallback() {
      const btn = $('.deferred-media__poster', this);
      btn && btn.addEventListener('click', () => this.load());
    }
    load() {
      if (this.loaded) return;
      const tpl = $('template', this);
      if (!tpl) return;
      this.loaded = true;
      const node = tpl.content.firstElementChild.cloneNode(true);
      this.appendChild(node);
      const btn = $('.deferred-media__poster', this);
      btn && btn.remove();
      if (node.tagName === 'VIDEO') node.play().catch(() => {});
    }
  }
  customElements.define('deferred-media', DeferredMedia);

  /* ---------- product: variant picker ---------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-product-section]');
      const json = $('script[type="application/json"]', this);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.addEventListener('change', () => this.onChange());
      this.updateAvailability();
    }
    selectedOptions() {
      const out = [];
      $$('fieldset[data-option], select[data-option]', this).forEach(el => {
        if (el.tagName === 'SELECT') out.push(el.value);
        else { const c = $('input:checked', el); out.push(c ? c.value : null); }
      });
      return out;
    }
    onChange() {
      const sel = this.selectedOptions();
      const v = this.variants.find(x => x.options.every((o, i) => o === sel[i]));
      $$('fieldset[data-option]', this).forEach((f, i) => { const s = $('[data-selected-value]', f); if (s) s.textContent = sel[i]; });
      this.updateAvailability();
      this.apply(v);
    }
    updateAvailability() {
      const sel = this.selectedOptions();
      $$('fieldset[data-option]', this).forEach((f, idx) => {
        $$('input', f).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const ok = this.variants.some(v => v.available && v.options.every((o, i) => i === idx ? o === inp.value : (i < idx ? o === test[i] : true)));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    apply(v) {
      const s = this.section;
      if (!s) return;
      $$('input[name="id"], select[name="id"]', s).forEach(i => { i.value = v ? v.id : ''; i.disabled = !v; i.dispatchEvent(new Event('change', { bubbles: true })); });
      if (v && this.updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-price-wrap]', s.ownerDocument).forEach(p => { if (p.closest('[data-product-section]') === s || p.dataset.sectionId === s.dataset.sectionId) VariantPicker.renderPrice(p, v); });
      $$('[data-add-button]', s.ownerDocument).forEach(b => {
        if (b.closest('[data-product-section]') !== s && b.dataset.sectionId !== s.dataset.sectionId) return;
        const label = $('[data-add-label]', b) || b;
        if (!v) { b.disabled = true; label.textContent = T.strings.unavailable; }
        else if (!v.available) { b.disabled = true; label.textContent = T.strings.soldOut; }
        else { b.disabled = false; label.textContent = b.dataset.addText || T.strings.addToCart; }
      });
      if (v && v.featured_media) {
        const g = $('media-gallery', s);
        g && g.goToMedia(v.featured_media.id);
      }
      $$('[data-sku]', s).forEach(el => { el.textContent = v && v.sku ? v.sku : ''; });
      $$('[data-inventory]', s).forEach(el => VariantPicker.renderInventory(el, v));
      emit('variant:change', { variant: v, sectionId: s.dataset.sectionId });
    }
    static renderPrice(wrap, v) {
      if (!v) return;
      const cur = $('[data-price]', wrap), cmp = $('[data-compare]', wrap), badge = $('[data-sale-badge]', wrap);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      wrap.classList.toggle('price--on-sale', !!onSale);
      if (cur) cur.textContent = formatMoney(v.price);
      if (cmp) { cmp.textContent = onSale ? formatMoney(v.compare_at_price) : ''; cmp.hidden = !onSale; }
      if (badge) {
        badge.hidden = !onSale;
        const txt = $('[data-badge-text]', badge);
        if (onSale && txt) {
          const tpl = badge.dataset.template || 'SALE';
          const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          txt.textContent = tpl.replace('[percentage]', pct).replace('[amount]', formatMoney(v.compare_at_price - v.price).replace(/[.,]00$/, ''));
        }
      }
    }
    static renderInventory(el, v) {
      if (!v) { el.hidden = true; return; }
      const data = (el._inv = el._inv || JSON.parse(el.dataset.inventory || '{}'));
      const q = data[v.id];
      const thr = parseInt(el.dataset.threshold, 10) || 10;
      el.hidden = false;
      const txt = $('[data-inventory-text]', el);
      el.classList.toggle('inventory--low', q != null && q > 0 && q <= thr);
      if (!txt) return;
      if (!v.available) txt.textContent = el.dataset.outText;
      else if (q != null && q > 0 && q <= thr) txt.textContent = el.dataset.lowText.replace('[count]', q);
      else txt.textContent = el.dataset.inText;
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* ---------- product form ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = $('form', this);
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }
    async onSubmit(e) {
      if (!this.form.checkValidity()) { e.preventDefault(); this.form.reportValidity(); return; } // novalidate skips required custom fields
      if (T.cartType !== 'drawer' || this.dataset.redirect === 'true') return; // native submit
      e.preventDefault();
      this.addNative();
    }
    async addNative() {
      const btn = $('[type=submit]', this.form);
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      const err = $('[data-form-error]', this);
      if (err) { err.hidden = true; err.textContent = ''; }
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
      try {
        const fd = new FormData(this.form);
        // Collect any extra add-ons ticked inside the product section (checkbox upsell block)
        const section = this.closest('[data-product-section]') || document;
        const items = [];
        const props = {};
        for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; }
        items.push({ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || 1, 10), properties: props, selling_plan: fd.get('selling_plan') || undefined });
        $$('[data-addon]:checked', section).forEach(c => items.push({ id: parseInt(c.value, 10), quantity: 1 }));
        await Cart.add({ items });
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message);
      } finally {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      }
    }
  }
  customElements.define('product-form', ProductForm);

  /* quantity input on product page */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pqty]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (b.dataset.pqty === 'plus' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- sticky add to cart ---------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = document.querySelector(`[data-product-section][data-section-id="${this.dataset.sectionId}"]`) || document.querySelector('[data-product-section]');
      this.target = this.section && ($('[data-add-button]', this.section) || $('product-form', this.section));
      this.footer = document.querySelector('.footer');
      this.visible = false;
      const check = () => {
        if (!this.target) return;
        const r = this.target.getBoundingClientRect();
        const passed = r.bottom < 0;
        const footerIn = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight && this.dataset.hideFooter === 'true';
        const show = (this.dataset.always === 'true' || passed) && !footerIn;
        if (show !== this.visible) {
          this.visible = show;
          this.classList.toggle('is-visible', show);
          document.body.classList.toggle('has-sticky-atc', show);
          if (show) document.body.style.setProperty('--sticky-h', this.offsetHeight + 'px');
        }
      };
      window.addEventListener('scroll', rafThrottle(check), { passive: true });
      check();

      const btn = $('[data-sticky-add]', this);
      const sel = $('select', this);
      if (sel) sel.addEventListener('change', () => {
        const picker = this.section && $('variant-picker', this.section);
        const v = picker && picker.variants.find(x => String(x.id) === sel.value);
        if (picker && v) {
          $$('fieldset[data-option]', picker).forEach((f, i) => { const inp = $$('input', f).find(n => n.value === v.options[i]); if (inp) inp.checked = true; });
          $$('select[data-option]', picker).forEach((s, i) => { s.value = v.options[i]; });
          picker.onChange();
        } else {
          $$('input[name="id"]', this.section || document).forEach(i => { i.value = sel.value; });
        }
      });
      btn && btn.addEventListener('click', () => {
        const action = this.dataset.action;
        const main = this.target && (this.target.matches('button') ? this.target : $('[type=submit]', this.target));
        if (action === 'scroll' || !main) {
          (this.section || document.body).scrollIntoView({ behavior: 'smooth' });
          return;
        }
        main.click(); // goes through the real form so bundle apps apply their selection
      });
      document.addEventListener('variant:change', (e) => {
        const v = e.detail.variant;
        const w = $('[data-price-wrap]', this);
        if (w) VariantPicker.renderPrice(w, v);
        if (sel && v) sel.value = v.id;
        if (btn && v) { btn.disabled = !v.available; const l = $('[data-add-label]', btn); if (l) l.textContent = v.available ? (btn.dataset.addText || T.strings.addToCart) : T.strings.soldOut; }
      });
    }
  }
  customElements.define('sticky-atc', StickyAtc);

  /* ---------- countdown ---------- */
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.out = $('[data-countdown]', this);
      const mode = this.dataset.mode;
      if (mode === 'date') { const v = (this.dataset.end || '').trim().replace(' ', 'T'); this.end = new Date(v.length === 10 ? v + 'T23:59:59' : v).getTime() || 0; }
      else if (mode === 'session') {
        const key = 'cl-cd-' + (this.dataset.key || 'x');
        let end = parseInt(SS.get(key), 10);
        if (!end || end < Date.now()) { end = Date.now() + (parseFloat(this.dataset.minutes) || 15) * 60000; SS.set(key, end); }
        this.end = end;
      } else if (mode === 'evergreen') {
        this.evergreen();
      } else {
        const d = new Date(); d.setHours(24, 0, 0, 0); this.end = d.getTime();
      }
      this.boxes = { d: $('[data-cd-d]', this), h: $('[data-cd-h]', this), m: $('[data-cd-m]', this), s: $('[data-cd-s]', this) };
      this.tick(); this.t = setInterval(() => this.tick(), 1000);
    }
    evergreen() {
      const key = 'cl-eg-' + (this.dataset.key || 'x'), len = (parseFloat(this.dataset.hours) || 24) * 3600000;
      let end; try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + len; try { localStorage.setItem(key, end); } catch (e) {} }
      this.end = end;
    }
    tick() {
      let s = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (s === 0) {
        const onEnd = this.dataset.onEnd || (this.dataset.hideOnEnd === 'true' ? 'hide' : 'stop');
        if (onEnd === 'restart' && this.dataset.mode === 'evergreen') { this.evergreen(); s = Math.floor((this.end - Date.now()) / 1000); }
        else if (onEnd === 'restart' && this.dataset.mode === 'daily') { const d = new Date(); d.setHours(24, 0, 0, 0); this.end = d.getTime(); s = Math.floor((this.end - Date.now()) / 1000); }
        else if (onEnd === 'hide') { (this.closest('[data-cd-hide-target]') || this).hidden = true; clearInterval(this.t); return; }
      }
      const p = (n) => String(n).padStart(2, '0');
      if (this.boxes && this.boxes.s) {
        const showDays = !!this.boxes.d;
        let r = s; const d = showDays ? Math.floor(r / 86400) : 0; r -= d * 86400;
        const h = Math.floor(r / 3600); r %= 3600; const m = Math.floor(r / 60); r %= 60;
        if (this.boxes.d) this.boxes.d.textContent = p(d);
        this.boxes.h.textContent = p(h); this.boxes.m.textContent = p(m); this.boxes.s.textContent = p(r);
        return;
      }
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      if (this.out) this.out.textContent = (d ? d + 'd ' : '') + (d || h ? `${p(h)}:` : '') + `${p(m)}:${p(s)}`;
    }
    disconnectedCallback() { clearInterval(this.t); }
  }
  customElements.define('countdown-timer', CountdownTimer);

  /* ---------- popup ---------- */
  class PromoPopup extends HTMLElement {
    connectedCallback() {
      this.key = 'cl-popup-' + (this.dataset.id || 'x');
      const days = parseFloat(this.dataset.days || 3);
      $$('[data-popup-close]', this).forEach(b => b.addEventListener('click', () => this.close()));
      this.addEventListener('close', () => this.close());
      const pop = $('.popup', this);
      pop && pop.addEventListener('close', () => this.close()); // Escape dispatches on .popup
      const teaser = $('[data-popup-teaser]', this);
      teaser && teaser.addEventListener('click', () => this.open(true));

      if (this.dataset.success === 'true') { this.open(true); return; }
      if (window.Shopify && Shopify.designMode) { if (this.dataset.designShow === 'true') this.open(true); return; }
      const last = this.dataset.mode === 'test' ? 0 : parseInt(LS.get(this.key), 10);
      if (last && Date.now() - last < days * 86400000) { if (teaser) teaser.classList.add('is-visible'); return; }
      if (this.dataset.mobile === 'false' && window.innerWidth < 750) return;

      const trig = this.dataset.trigger;
      const dl = parseFloat(this.dataset.delay);
      const delay = (isNaN(dl) ? 5 : dl) * 1000;
      if (trig === 'delay') setTimeout(() => this.open(), delay);
      if (trig === 'scroll') {
        const f = () => { if (window.scrollY / (document.body.scrollHeight - innerHeight) > (parseFloat(this.dataset.scroll) || 40) / 100) { this.open(); window.removeEventListener('scroll', f); } };
        window.addEventListener('scroll', f, { passive: true });
      }
      if (trig === 'exit') {
        document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 10) this.open(); });
        if (window.innerWidth < 750) setTimeout(() => this.open(), delay); // no exit intent on phones
      }
    }
    open(force) {
      if (this.opened && !force) return;
      this.opened = true;
      $('.popup', this).classList.add('is-open');
      lockScroll(true, 'popup');
      LS.set(this.key, Date.now());
      const t = $('[data-popup-teaser]', this); t && t.classList.remove('is-visible');
    }
    close() {
      const p = $('.popup', this);
      if (!p.classList.contains('is-open')) return;
      p.classList.remove('is-open');
      lockScroll(false, 'popup');
      const t = $('[data-popup-teaser]', this); t && t.classList.add('is-visible');
    }
  }
  customElements.define('promo-popup', PromoPopup);

  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-copy]');
    if (!c) return;
    copyText(c.dataset.copy).then(() => toast(c.dataset.copied || 'Copied!'), () => {});
  });

  /* ---------- scroll to top ---------- */
  class ScrollTop extends HTMLElement {
    connectedCallback() {
      const b = $('button', this);
      const f = () => b.classList.toggle('is-visible', window.scrollY > (parseInt(this.dataset.offset, 10) || 400));
      window.addEventListener('scroll', rafThrottle(f), { passive: true }); f();
      b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  }
  customElements.define('scroll-top', ScrollTop);

  /* ---------- music player ---------- */
  class MusicPlayer extends HTMLElement {
    connectedCallback() {
      this.audio = $('audio', this);
      this.btn = $('.music-player__btn', this);
      this.box = $('.music-player', this);
      if (!this.audio || !this.btn) return;
      this.audio.volume = (parseInt(this.dataset.volume, 10) || 40) / 100;
      this.btn.addEventListener('click', () => this.toggle());
      const wasOff = SS.get('cl-music') === 'off';
      if (this.dataset.autoplay === 'true' && !wasOff) {
        const start = () => { if (SS.get('cl-music') !== 'off') this.play(); ['pointerdown', 'keydown', 'scroll'].forEach(ev => window.removeEventListener(ev, start)); };
        ['pointerdown', 'keydown'].forEach(ev => window.addEventListener(ev, start, { once: true }));
      }
    }
    play() { this.audio.play().then(() => { this.box.classList.add('is-playing'); this.btn.setAttribute('aria-pressed', 'true'); }).catch(() => {}); }
    pause() { this.audio.pause(); this.box.classList.remove('is-playing'); this.btn.setAttribute('aria-pressed', 'false'); }
    toggle() { if (this.audio.paused) { SS.set('cl-music', 'on'); this.play(); } else { SS.set('cl-music', 'off'); this.pause(); } }
  }
  customElements.define('music-player', MusicPlayer);

  /* ---------- share ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    const url = b.dataset.share;
    if (navigator.share) navigator.share({ url, title: document.title }).catch(() => {});
    else copyText(url).then(() => toast(b.dataset.copied || 'Link copied'), () => {});
  });

  /* ---------- facets ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('[data-facets-form]');
    if (f && !e.target.matches('[data-price-input]')) f.submit();
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-facets-form]');
    if (!f) return;
    // drop empty price fields so the URL stays clean
    $$('[data-price-input]', f).forEach(i => { if (!i.value) i.disabled = true; });
  });

  /* ---------- simple sliders (testimonials, cards) ---------- */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-slider-track]', this);
      if (!this.track) return;
      this.bars = $$('[data-slider-bar]', this);
      $$('[data-slider-prev]', this).forEach(b => b.addEventListener('click', () => this.step(-1)));
      $$('[data-slider-next]', this).forEach(b => b.addEventListener('click', () => this.step(1)));
      this.track.addEventListener('scroll', debounce(() => this.update(), 50), { passive: true });
      const auto = parseInt(this.dataset.autoplay, 10);
      if (auto) {
        this.timer = setInterval(() => { if (!this.matches(':hover')) this.step(1, true); }, auto * 1000);
      }
      this.update();
    }
    step(dir, loop) {
      const item = this.track.children[0];
      if (!item) return;
      const w = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (loop && dir > 0 && this.track.scrollLeft >= max) this.track.scrollTo({ left: 0, behavior: 'smooth' });
      else this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    update() {
      if (!this.bars.length) return;
      const item = this.track.children[0];
      const w = item ? item.getBoundingClientRect().width : 1;
      const i = Math.round(this.track.scrollLeft / w);
      this.bars.forEach((b, k) => b.classList.toggle('is-active', k === i));
      this.bars.forEach((b, k) => b.classList.toggle('is-done', k < i));
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('slider-component', SliderComponent);

  /* ---------- reveal on scroll ---------- */
  function initReveal(root = document) {
    if (!document.body.classList.contains('has-reveal')) return;
    $$('[data-reveal-children]', root).forEach(p => Array.from(p.children).forEach((c, i) => { c.classList.add('reveal'); c.style.setProperty('--i', Math.min(i, 4)); }));
    const els = $$('.reveal:not(.is-in)', root);
    window.__revealReady = true;
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const repeat = document.body.dataset.revealRepeat === 'true';
    /* backup for in-app browsers where the observer misfires: reveal anything on screen while scrolling */
    if (!repeat && !window.__revealSweep) {
      const sweep = rafThrottle(() => {
        const left = $$('.reveal:not(.is-in)');
        if (!left.length) return;
        const h = window.innerHeight;
        left.forEach(e => { const r = e.getBoundingClientRect(); if (r.height && r.top < h && r.bottom > 0) e.classList.add('is-in'); });
      });
      window.__revealSweep = true;
      window.addEventListener('scroll', sweep, { passive: true });
      window.addEventListener('resize', sweep, { passive: true });
      setTimeout(sweep, 1200);
    }
    const io = new IntersectionObserver((entries) => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); if (!repeat) io.unobserve(en.target); }
      else if (repeat) en.target.classList.remove('is-in');
    }), { rootMargin: '0px 0px 0px 0px' });
    els.forEach(e => io.observe(e));
  }
  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    document.body.dataset.hideZeroDecimals = document.body.dataset.hideZeroDecimals || 'false';
    if (new URLSearchParams(location.search).get('open_cart') === '1') Cart.open();
  });
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));

  /* ---------- autoplay rescue ----------
     Some in-app browsers and iPhone Low Power Mode block muted autoplay until the first touch.
     On the first touches and scrolls, start any on-screen autoplay video that never started. */
  (function () {
    const wake = rafThrottle(() => {
      $$('video').forEach(v => {
        if (v.dataset.woke || !v.paused || !(v.autoplay || v.dataset.autoplay === 'true') || !(v.muted || v.hasAttribute('muted'))) return;
        const r = v.getBoundingClientRect();
        if (!r.width || r.bottom <= 0 || r.top >= window.innerHeight || r.right <= 0 || r.left >= window.innerWidth) return;
        v.muted = true; v.playsInline = true;
        const p = v.play(); if (p && p.catch) p.catch(() => {});
      });
    });
    document.addEventListener('playing', (e) => { if (e.target.tagName === 'VIDEO') e.target.dataset.woke = '1'; }, true);
    ['touchstart', 'pointerdown', 'scroll'].forEach(ev => window.addEventListener(ev, wake, { passive: true }));
  })();

  /* ---------- content protection ---------- */
  if (document.documentElement && document.body && document.body.dataset.protect === 'true' && !(window.Shopify && Shopify.designMode)) {
    document.addEventListener('contextmenu', e => { if (!e.target.closest('input,textarea')) e.preventDefault(); });
    const editable = (t) => t && t.closest && t.closest('input,textarea,select,[contenteditable="true"]');
    document.addEventListener('dragstart', e => { if (!editable(e.target)) e.preventDefault(); });
    ['copy', 'cut'].forEach(ev => document.addEventListener(ev, e => { if (!editable(e.target)) e.preventDefault(); }));
    document.addEventListener('selectstart', e => { if (!editable(e.target)) e.preventDefault(); });
    document.documentElement.classList.add('is-protected');
    const noDl = () => $$('video').forEach(v => { v.setAttribute('controlsList', 'nodownload'); v.disablePictureInPicture = true; });
    noDl(); new MutationObserver(noDl).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('keydown', e => {
      const k = e.key.toLowerCase();
      if (k === 'f12' || ((e.ctrlKey || e.metaKey) && (k === 'u' || k === 's' || ((k === 'c' || k === 'a') && !editable(e.target)) || (e.shiftKey && ['i', 'j', 'c'].includes(k))))) e.preventDefault();
    });
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) Cart.open();
    const p = e.target.querySelector('promo-popup');
    if (p) p.open(true);
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('#CartDrawer')) Cart.close();
    const p = e.target.querySelector('promo-popup');
    if (p) p.close();
  });
})();

/* ===== Payrick extras ===== */
(function () {
  'use strict';
  const T = window.theme;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const lock = (on) => T.lockScroll(on, 'modal');

  /* modal dialogs (product pop-up / size chart) */
  class ModalDialog extends HTMLElement {
    connectedCallback() {
      if (this.parentNode !== document.body) { document.body.appendChild(this); return; } // escape transformed parents (re-runs connectedCallback)
      $$('[data-modal-close]', this).forEach(b => b.addEventListener('click', () => this.hide()));
      this.addEventListener('close', () => this.hide());
    }
    show() { this.classList.add('is-open'); lock(true); }
    hide() { this.classList.remove('is-open'); lock(false); }
  }
  customElements.define('modal-dialog', ModalDialog);
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-modal-open]');
    if (!b) return;
    const m = document.getElementById(b.dataset.modalOpen);
    if (m) { e.preventDefault(); m.show(); }
  });

  /* recommendations (related + complementary) */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = () => {
        fetch(this.dataset.url).then(r => r.text()).then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          if (this.classList.contains('complementary')) {
            const c = doc.querySelector('[data-recs-compact]');
            const target = $('[data-recs]', this);
            if (c && c.innerHTML.trim() && target) target.innerHTML = c.innerHTML; else this.hidden = true;
          } else {
            const f = doc.querySelector('[data-recs-full]');
            if (f) this.innerHTML = f.outerHTML; else this.closest('.shopify-section') && (this.closest('.shopify-section').hidden = true);
          }
        }).catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else load();
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* discount codes: chip + cart field */
  async function applyDiscount(code) {
    await fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });
    if (T.cart) await T.cart.refresh();
  }
  document.addEventListener('click', async (e) => {
    const chip = e.target.closest('[data-discount]');
    if (chip) {
      e.preventDefault();
      const code = chip.dataset.discount;
      copyText(code).catch(() => {});
      await applyDiscount(code);
      chip.classList.add('is-applied');
      T.toast && T.toast(chip.dataset.copied || 'Applied');
      return;
    }
    const ap = e.target.closest('[data-apply-discount]');
    if (ap) {
      e.preventDefault();
      const wrap = ap.closest('[data-discount-field]');
      const input = $('input', wrap);
      const code = input.value.trim();
      if (!code) return;
      ap.classList.add('loading');
      await applyDiscount(code);
      ap.classList.remove('loading');
      T.toast && T.toast(`Code ${code} will apply at checkout`);
    }
  });

  /* scroll to buy box (works with Kaching) */
  function scrollToBuy() {
    const target = $('kaching-bundles-block') || $('[class*="kaching"]') || $('[data-product-section] product-form') || $('[data-product-section]');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-scroll-buy]');
    if (a && (a.getAttribute('href') === '#buy' || a.getAttribute('href') === '')) { e.preventDefault(); scrollToBuy(); return; }
    const t = e.target.closest('[data-scroll-to]');
    if (t) {
      const el = document.getElementById(t.dataset.scrollTo);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* bundle offer tiers set the quantity */
  document.addEventListener('change', (e) => {
    const r = e.target.closest('[data-bundle-qty]');
    if (!r) return;
    const box = r.closest('[data-bundle]');
    $$('.bundle-tier', box).forEach(t => t.classList.toggle('is-selected', $('input', t).checked));
    const section = r.closest('[data-product-section]');
    const form = section && $('product-form form', section);
    if (!form) return;
    let q = $('input[name="quantity"]', section);
    if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; form.appendChild(q); }
    q.value = r.value;
  });

  /* FAQ: smooth open/close (grid 0fr->1fr), one open at a time */
  document.documentElement.classList.add('faq-anim');
  const faqSet = (d, on) => {
    clearTimeout(d._ft);
    if (on) { d.open = true; requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open'))); }
    else { d.classList.remove('is-open'); d._ft = setTimeout(() => { if (!d.classList.contains('is-open')) d.open = false; }, 360); }
  };
  document.addEventListener('click', (e) => {
    const sum = e.target.closest('.faq__item > summary');
    if (!sum) return;
    e.preventDefault();
    const d = sum.parentNode, on = !d.classList.contains('is-open');
    if (on) { const group = d.closest('[data-one-open]'); if (group) $$('.faq__item.is-open', group).forEach(x => { if (x !== d) faqSet(x, false); }); }
    faqSet(d, on);
  });
  document.addEventListener('shopify:block:select', (e) => { const d = e.target.closest && e.target.closest('.faq__item'); if (d) faqSet(d, true); });

  /* stories (testimonials one at a time with progress bars) */
  class StorySlider extends HTMLElement {
    connectedCallback() {
      this.cards = $$('.stories__track > *', this);
      this.bars = $$('.stories__bars button', this);
      this.delay = (parseFloat(this.dataset.delay) || 7) * 1000;
      this.style.setProperty('--story-delay', this.delay + 'ms');
      this.i = 0; this.playing = false; this.visible = false;
      this.render(false);
      this.bars.forEach((b, k) => b.addEventListener('click', (e) => { e.stopPropagation(); this.nav(k); }));
      const track = $('.stories__track', this);
      let sx = 0, sy = 0, lockDir = 0;
      track.addEventListener('touchstart', (e) => { const p = e.changedTouches[0]; sx = p.clientX; sy = p.clientY; lockDir = 0; }, { passive: true });
      track.addEventListener('touchmove', (e) => { const p = e.changedTouches[0]; const dx = p.clientX - sx, dy = p.clientY - sy; if (!lockDir && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) lockDir = Math.abs(dx) > Math.abs(dy) ? 1 : 2; }, { passive: true });
      track.addEventListener('touchend', (e) => { if (lockDir === 1) { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) this.nav(dx < 0 ? this.i + 1 : this.i - 1); } this.swiped = lockDir !== 0; }, { passive: true });
      track.addEventListener('click', () => { if (this.swiped) { this.swiped = false; return; } this.nav(this.i + 1); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((es) => { this.visible = es[0].isIntersecting; this.visible ? this.play() : this.pause(); }, { threshold: .4 }).observe(this);
      } else { this.visible = true; this.play(); }
      if (window.Shopify && Shopify.designMode) this.addEventListener('shopify:block:select', (e) => { const k = this.cards.indexOf(e.target); if (k > -1) this.nav(k); });
    }
    render(anim) {
      this.cards.forEach((c, k) => c.classList.toggle('is-on', k === this.i));
      this.bars.forEach((b, k) => { b.classList.remove('is-on', 'is-done'); if (k < this.i) b.classList.add('is-done'); });
      const b = this.bars[this.i];
      if (!b) return;
      if (anim) { void b.offsetWidth; b.classList.add('is-on'); } else b.classList.add('is-done');
    }
    schedule() { clearTimeout(this.t); if (this.playing) this.t = setTimeout(() => { this.i = (this.i + 1) % this.cards.length; this.render(true); this.schedule(); }, this.delay); }
    play() { if (this.playing || !this.visible || this.cards.length < 2) return; this.playing = true; this.render(true); this.schedule(); }
    pause() { this.playing = false; clearTimeout(this.t); }
    nav(n) { this.pause(); clearTimeout(this.idle); this.i = (n + this.cards.length) % this.cards.length; this.render(false); this.idle = setTimeout(() => this.visible && this.play(), 8000); }
  }
  customElements.define('story-slider', StorySlider);

  /* lifestyle rail (swipe cards with progress, autoplay on mobile) */
  class StoryRail extends HTMLElement {
    connectedCallback() {
      this.track = $('.rail__track', this);
      this.cards = Array.from(this.track.children);
      this.bars = $$('.rail__progress button', this);
      this.delay = (parseFloat(this.dataset.delay) || 4.5) * 1000;
      this.style.setProperty('--rail-delay', this.delay + 'ms');
      this.mq = window.matchMedia('(min-width: 990px)');
      this.i = 0; this.hold = false; this.vis = false;
      const go = (n) => { this.track.scrollTo({ left: this.cards[n].offsetLeft - this.cards[0].offsetLeft, behavior: 'smooth' }); this.mark(n); };
      this.go = go;
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.st);
        this.st = setTimeout(() => {
          const x = this.track.scrollLeft; let best = 0, d = 1e9;
          this.cards.forEach((c, k) => { const e = Math.abs(c.offsetLeft - this.cards[0].offsetLeft - x); if (e < d) { d = e; best = k; } });
          if (best !== this.i) this.mark(best);
        }, 120);
      }, { passive: true });
      const pause = () => { this.hold = true; clearTimeout(this.t); clearTimeout(this.rt); this.classList.add('is-paused'); };
      const resume = () => { clearTimeout(this.rt); this.rt = setTimeout(() => { this.hold = false; this.mark(this.i); this.loop(); }, 5000); };
      this.track.addEventListener('touchstart', pause, { passive: true });
      this.track.addEventListener('touchend', resume, { passive: true });
      this.track.addEventListener('mouseenter', pause);
      this.track.addEventListener('mouseleave', resume);
      this.bars.forEach((b, k) => b.addEventListener('click', () => { pause(); go(k); resume(); }));
      if ('IntersectionObserver' in window) new IntersectionObserver((es) => { this.vis = es[0].isIntersecting; this.mark(this.i); this.vis ? this.loop() : clearTimeout(this.t); }, { threshold: .45 }).observe(this);
      this.mark(0);
    }
    mark(n) {
      this.i = n;
      this.cards.forEach((c, k) => c.classList.toggle('is-on', k === n));
      this.bars.forEach((b, k) => { b.classList.toggle('is-done', k < n); b.classList.remove('is-on'); });
      if (this.bars[n]) { void this.offsetWidth; this.bars[n].classList.add('is-on'); }
      this.classList.toggle('is-paused', this.hold || !this.vis);
    }
    loop() { clearTimeout(this.t); if (this.hold || !this.vis || this.mq.matches || this.cards.length < 2) return; this.t = setTimeout(() => { this.go((this.i + 1) % this.cards.length); this.loop(); }, this.delay); }
  }
  customElements.define('story-rail', StoryRail);
})();

/* ticker: constant pixel speed no matter how much text */
customElements.define('marquee-track', class extends HTMLElement {
  connectedCallback() {
    const set = () => {
      const px = parseFloat(getComputedStyle(this.closest('.announcement')).getPropertyValue('--px-speed')) || 35;
      const dist = this.scrollWidth / 2;
      if (dist > 0) this.style.animationDuration = (dist / px) + 's';
    };
    set();
    window.addEventListener('resize', set);
    if (document.fonts) document.fonts.ready.then(set);
  }
});

/* heading highlight effects + typewriter (Typography settings) */
(function () {
  'use strict';
  const SEL = 'h1 em, h2 em, h3 em, .heading em, .h0 em, .h1 em, .h2 em';
  const NS = 'http://www.w3.org/2000/svg';
  const PATHS = {
    scribble: ['0 0 200 20', 'M3 12C24 5 38 16 58 10S92 4 112 11S150 16 170 9S192 7 197 10', 3.5],
    circle: ['0 0 200 80', 'M118 7C64 1 12 14 7 38C2 64 62 77 116 74C168 71 197 54 193 32C189 11 148 2 84 9', 2.6]
  };
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fx = () => { const m = document.body.className.match(/\bhl-fx-([a-z]+)/); return m ? m[1] : 'none'; };
  let io;

  function addSvg(em, kind) {
    if (em.querySelector(':scope > .hl-svg')) return;
    const p = PATHS[kind];
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'hl-svg hl-svg--' + kind);
    svg.setAttribute('viewBox', p[0]);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('d', p[1]);
    path.setAttribute('pathLength', '1');
    path.setAttribute('stroke-width', p[2]);
    svg.appendChild(path);
    em.appendChild(svg);
  }

  function prepType(em) {
    if (em.querySelector(':scope > .hl-typed')) return;
    const text = em.textContent;
    if (!text.trim()) return;
    em.dataset.hlText = text;
    em.innerHTML = '';
    const sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = text;
    const ghost = document.createElement('span'); ghost.className = 'hl-ghost'; ghost.setAttribute('aria-hidden', 'true'); ghost.textContent = text;
    const typed = document.createElement('span'); typed.className = 'hl-typed'; typed.setAttribute('aria-hidden', 'true');
    em.append(sr, ghost, typed);
  }

  function play(em) {
    const typed = em.querySelector(':scope > .hl-typed');
    if (!typed || reduce()) {
      if (typed) { typed.textContent = em.dataset.hlText || ''; em.classList.add('is-typed-done'); }
      em.classList.add('is-hl-in');
      return;
    }
    const text = em.dataset.hlText || '';
    const step = Math.max(28, Math.min(70, 900 / Math.max(text.length, 1)));
    let i = 0;
    typed.textContent = '';
    setTimeout(function tick() {
      i++;
      typed.textContent = text.slice(0, i);
      if (i < text.length) setTimeout(tick, step);
      else { em.classList.add('is-typed-done'); em.classList.add('is-hl-in'); }
    }, 150);
  }

  function init(root) {
    const body = document.body;
    const kind = fx();
    const type = body.classList.contains('hl-type');
    if (kind === 'none' && !type) return;
    if (!io) io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); play(e.target); } });
    }, { threshold: 0.6 }) : null;
    (root || document).querySelectorAll(SEL).forEach((em) => {
      if (em.classList.contains('hl-w')) return;
      if (em.parentElement && em.parentElement.closest('em.hl-w')) return;
      em.classList.add('hl-w');
      if (type) prepType(em);
      if (kind === 'scribble' || kind === 'circle') addSvg(em, kind);
      if (io && !reduce()) io.observe(em); else play(em);
    });
  }

  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* button click ripple (Buttons > Click ripple effect) */
(function () {
  'use strict';
  document.addEventListener('pointerdown', (e) => {
    if (e.button !== 0 || document.body.classList.contains('no-ripple')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const btn = e.target.closest && e.target.closest('.button, .shopify-payment-button__button');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    const r = btn.getBoundingClientRect();
    const size = Math.max(r.width, r.height) / 2;
    const dot = document.createElement('span');
    dot.className = 'btn-ripple';
    dot.setAttribute('aria-hidden', 'true');
    dot.style.width = dot.style.height = size + 'px';
    dot.style.left = (e.clientX - r.left - size / 2) + 'px';
    dot.style.top = (e.clientY - r.top - size / 2) + 'px';
    btn.classList.add('btn-ripple-host');
    btn.appendChild(dot);
    const done = () => { dot.remove(); if (!btn.querySelector('.btn-ripple')) btn.classList.remove('btn-ripple-host'); };
    dot.addEventListener('animationend', done, { once: true });
    setTimeout(done, 900);
  }, { passive: true });
})();

/* shape divider: auto-match the colors of the sections above and below */
(() => {
  const opaque = (c) => c && c !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(c);
  const bgOf = (sec) => {
    if (!sec) return null;
    const q = [sec]; let n = 0;
    while (q.length && n < 40) {
      const el = q.shift(); n++;
      const c = getComputedStyle(el).backgroundColor;
      if (opaque(c) && el.offsetHeight > 20) return c;
      for (const ch of el.children) if (ch.offsetHeight > 20) q.push(ch);
    }
    return null;
  };
  const sib = (sec, dir) => {
    let el = sec;
    while ((el = dir < 0 ? el.previousElementSibling : el.nextElementSibling)) {
      if (el.matches('.shopify-section, section, footer, header, [id^="shopify-section"]') && el.offsetHeight > 0 && getComputedStyle(el).position !== 'fixed') return el;
    }
    // jump across main/header/footer wrappers
    const wrap = sec.parentElement && sec.parentElement.closest('main, header, footer, body');
    if (wrap && wrap !== document.body) return sib(wrap, dir);
    return null;
  };
  class ShapeDivider extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.sync()); window.addEventListener('load', () => this.sync(), { once: true }); }
    sync() {
      const sec = this.closest('.shopify-section') || this;
      const body = getComputedStyle(document.body).backgroundColor;
      if (this.dataset.autoAbove) this.style.setProperty('--above', bgOf(sib(sec, -1)) || body);
      if (this.dataset.autoBelow) this.style.setProperty('--below', bgOf(sib(sec, 1)) || body);
      const cs = getComputedStyle(this);
      const same = cs.getPropertyValue('--above').trim() === cs.getPropertyValue('--below').trim();
      this.classList.toggle('is-same', same && !!(window.Shopify && Shopify.designMode));
    }
  }
  if (!customElements.get('shape-divider')) customElements.define('shape-divider', ShapeDivider);
  const resync = () => document.querySelectorAll('shape-divider').forEach((d) => d.sync && d.sync());
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select'].forEach((ev) => document.addEventListener(ev, () => setTimeout(resync, 60)));
})();
